import { FilmStrip } from "@phosphor-icons/react";
import { useTranslation } from "@/contexts/LanguageContext";

export const CameraTypesBadge = ({ testId = "camera-types-badge" }) => {
  const { lang } = useTranslation();
  return (
    <span
      data-testid={testId}
      className="inline-flex items-center gap-2 rounded-full border border-[#F5A524]/40 bg-[#F5A524]/10 px-4 py-1.5 text-[#F5A524] text-xs sm:text-sm font-semibold"
    >
      <FilmStrip weight="fill" className="w-4 h-4" />
      {lang === "es" ? "Para DSLR · Mirrorless · Película" : "Works with DSLR · Mirrorless · Film"}
    </span>
  );
};
